import React, { FC } from "react";
import "./content-loaders.scss";

interface BookingListLoaderProps {
  count?: number;
}

const BookingListItemLoader: FC = () => (
  <article className="bookingDataBlock bookingListCard contentLoader__bookingCard mb-2" aria-hidden="true">
    <div className="bookingListCard__layout">
      <div className="bookingListCard__userCol">
        <span className="userImage contentLoader__shimmer d-block" />
        <div className="bookingListCard__userBody flex-fill">
          <div className="contentLoader__shimmer mb-2" style={{ height: 20, width: "65%" }} />
          <div className="contentLoader__shimmer mb-2" style={{ height: 14, width: "50%" }} />
          <div className="contentLoader__shimmer mb-3" style={{ height: 14, width: "60%" }} />
          <div className="row g-2">
            {Array.from({ length: 3 }).map((_, index) => (
              <div className="col-4" key={index}>
                <div className="contentLoader__shimmer mb-1" style={{ height: 10, width: "80%" }} />
                <div className="contentLoader__shimmer" style={{ height: 14, width: "100%" }} />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="bookingListCard__courseCol">
        <div className="contentLoader__shimmer mb-2" style={{ height: 18, width: "75%" }} />
        <div className="contentLoader__shimmer mb-2" style={{ height: 14, width: "90%" }} />
        <div className="contentLoader__shimmer mb-2" style={{ height: 12, width: "40%" }} />
        <div className="contentLoader__shimmer" style={{ height: 14, width: "55%" }} />
      </div>
      <div className="bookingListCard__actionsCol">
        <div className="contentLoader__shimmer mb-3" style={{ height: 28, width: 28, borderRadius: "50%" }} />
        <div className="contentLoader__shimmer mb-2" style={{ height: 14, width: "80%" }} />
        <div className="contentLoader__shimmer" style={{ height: 36, width: "100%" }} />
      </div>
    </div>
  </article>
);

const BookingListLoader: FC<BookingListLoaderProps> = ({ count = 3 }) => (
  <div className="bookingsListWrapper contentLoader contentLoader--bookings" aria-busy="true" aria-label="Loading bookings">
    {Array.from({ length: count }).map((_, index) => (
      <BookingListItemLoader key={index} />
    ))}
  </div>
);

export default BookingListLoader;
